import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SearchRouter } from '../../../search/types';
import { modules } from '../../modules';

@injectable()
export class SearchRouterService implements SearchRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToNews(newsId: string) {
    this.history.push({
      pathname: `/${modules.news.basename}/${newsId}`,
    });
  }

  goToComment(newsId: string, commentId: string) {
    this.history.push({
      pathname: `/${modules.news.basename}/${newsId}`,
      hash: `#comment-${commentId}`,
    });
  }

  goToSurvey(surveyId: string) {
    this.history.push({
      pathname: `/${modules.surveys.basename}/${surveyId}`,
    });
  }

  goToCommunity(communityId: string, slug: string) {
    this.history.push({
      pathname: `/${modules.community.basename}/${communityId}/${slug}`,
    });
  }

  goToCommunityPost(communityId: string, slug: string, postId: string) {
    window.open(
      `/${modules.community.basename}/${communityId}/${slug}/post/${postId}`,
      '_blank',
    );
  }

  goToCommunityPostComment(
    communityId: string,
    slug: string,
    postId: string,
    commentId: string,
  ) {
    this.history.push({
      pathname: `/${modules.community.basename}/${communityId}/${slug}/post/${postId}`,
      hash: `#comment-${commentId}`,
    });
  }
}
